import * as React from 'react';
import { SelectMultipleContext } from './SelectMultipleContext';
/** Hook to access the [[SelectMultipleContext]]. */
export function useSelectMultiple() {
    var context = React.useContext(SelectMultipleContext);
    if (!context) {
        throw new Error('useSelectMultiple must be used within a SelectMultipleProvider');
    }
    return context;
}
//# sourceMappingURL=useSelectMultiple.js.map